import { useEffect, useState } from 'react'

export function useSheetContext(): boolean {
  const [isInSheet, setIsInSheet] = useState(false)

  useEffect(() => {
    const checkForSheet = () => {
      // Check if there are any sheet overlays or content in the DOM
      const sheetOverlays = document.querySelectorAll('[data-slot="sheet-overlay"]')
      const sheetContents = document.querySelectorAll('[data-slot="sheet-content"]')

      // If we find sheet elements, we're likely in a sheet context
      const hasSheetElements = sheetOverlays.length > 0 || sheetContents.length > 0

      setIsInSheet(hasSheetElements)
    }

    // Check immediately
    checkForSheet()

    // Set up a mutation observer to watch for sheet elements being added/removed
    const observer = new MutationObserver(checkForSheet)
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-slot'],
    })

    return () => observer.disconnect()
  }, [])

  return isInSheet
}
